import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./Info.css";
import { translations, normalizeLang } from "../../i18n";


const Info = () => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const user = useSelector((state) => state.user.data);

  const lang = normalizeLang(user?.languageCode);
    const t = translations[lang];

  return (
    <div className="infoContainer">
      <div className="infoDescription">
        <svg
          className="infoDescriptionIcon"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8.5" cy="4.75" r="0.75" fill="black" />
          <path
            d="M7.75 7H8.5V12.25M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <p className="infoDescriptionIconP">{t.faqPage.title}</p>
      </div>

      <div className="infoContent">
        {t.faqPage.questions.map((q) => (
          <div key={q.id} className="questionContainer">
            <div className="questionButton" onClick={() => toggle(q.id)}>
              <p>{q.title}</p>
              <svg
                width="6"
                height="13"
                style={{
                  transform: openId === q.id ? "rotate(90deg)" : "rotate(0deg)",
                  transition: "0.3s ease",
                }}
                viewBox="0 0 6 13"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.307096 0.179318C-0.0457526 0.461597 -0.102961 0.97647 0.179318 1.32932L4.13404 6.27273L0.179318 11.2161C-0.102961 11.569 -0.0457532 12.0839 0.307096 12.3661C0.659945 12.6484 1.17482 12.5912 1.4571 12.2384L5.82071 6.78384C6.05976 6.48502 6.05976 6.06043 5.82071 5.76161L1.4571 0.307096C1.17482 -0.0457526 0.659945 -0.102961 0.307096 0.179318Z"
                  fill="#366091"
                />
              </svg>
            </div>
            <div className={`answer ${openId === q.id ? "open" : ""}`}>
              <p style={{ opacity: "0.8", fontSize: "12px" }}>
                {typeof q.answer === "function" ? q.answer({ Link }) : q.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Info;
